export default {"src":"/_next/static/media/airplane.a3d47eac.svg","height":27,"width":38,"blurWidth":0,"blurHeight":0};